import React, { Component } from 'react';
import "./Ticker.scss"
import Timecode from './Timecode';
import { Timer } from "./Timer"
import { _getNextGame, _getGames } from "../../Services/Fetch/gameinfo"
import { getTimerNextGame } from "../HandleGames"

class Ticker extends Component {
    constructor(props) {
        super();
        this.state = {}
    }
    componentWillReceiveProps(nextProps) {
        Timer(`${getTimerNextGame(nextProps.data)}`, {
            seconds: this.timerSeconds,
            minutes: this.timerMinutes,
            hours: this.timerHours
        });
    }
    render() {
        return (
            <div className="gameticker">
                <div className="flexable">
                    <div className="part1">
                        <div className="text">
                            המשחק הבא<span> בעוד</span>
                        </div>
                    </div>
                    <div className="part2">
                        <div className="text">
                            בעוד
                        </div>
                        <div className="timer">
                            <Timecode time={0} id="timer_seconds" ref={timerSeconds => this.timerSeconds = timerSeconds} desc="שניות" />
                            <Timecode time={0} id="timer_minutes" ref={timerMinutes => this.timerMinutes = timerMinutes} desc="דקות" />
                            <Timecode time={0} id="timer_hours" ref={timerHours => this.timerHours = timerHours} desc="שעות" isEnd />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Ticker;



// WEBPACK FOOTER //
// ./src/Components/NextGame/Ticker/Ticker.jsx